import axios from 'axios'
import { passThroughAxios } from './passThrough.axios'

export default {
  async searchDealerCustomers(query) {
    const result = await axios.get('SearchDealerCustomers', {
      params: {
        query,
      },
    })

    if (result.status == 200) return result.data

    return []
  },
  async searchCompanyRelations(customerCompanyMagicNumber) {
    const result = await axios.get('GetCustomerCompanyRelation', {
      params: {
        customerCompanyMagicNumber,
      },
    })

    if (result.status == 200) return result.data

    return []
  },
  async searchRelationsByLicensePlate(query) {
    const result = await axios.get('SearchRelationsByLicensePlate', {
      params: {
        query,
      },
    })

    if (result.status == 200) return result.data

    return []
  },
  async getCustomerByMagicNumber(query) {
    const result = await axios.get('GetCustomerByMagicNumber', {
      params: {
        magicNumber: query.magicNumber,
        type: query.type,
      },
    })

    if (result.status == 200) return result.data

    return []
  },
  async postCustomerCompanyRelation(query) {
    try {
      const result = await axios.post('PostCustomerCompanyRelation', query)

      return result.data
    } catch (e) {
      return Promise.reject(e)
    }
  },
  async postCustomerVehicleRelation(query) {
    try {
      const result = await axios.post('PostCustomerVehicleRelation', query)

      return result.data
    } catch (e) {
      return Promise.reject(e)
    }
  },
  async searchByAddress(address) {
    const result = await axios.get('searchaccountbyzipcode', {
      params: {
        zipcode: address.zipcode,
        housenumber: address.housenumber,
        phonenumber: address.phonenumber,
      },
    })

    if (result.status == 200) return result.data

    return []
  },
  async updateAccount(customer, dealerId, quoteId) {
    const result = await axios.post(`updatepcqmcustomer/${dealerId}/${quoteId}`, customer)
    if (result.status == 200) return result.data

    return {}
  },
  async createAccount(customer, quoteId) {
    const result = await axios.post(
      `CreateAccount${quoteId ? `?quoteId=${quoteId}` : ''}`,
      customer
    )

    if (result.status == 200) {
      return result.data
    } else {
      return {}
    }
  },
  async searchNationalCustomersByPoId(poId) {
    const result = await axios.get('SearchNationalCustomers', {
      params: {
        poId: poId,
      },
    })
    if (result.status === 200) {
      return result.data
    }
  },
  async searchNationalCustomers(searchParams) {
    const { phoneNumber, zipcode, houseNumber, poId, email } = searchParams

    const result = await axios.get('SearchNationalCustomers', {
      params: {
        zipcode,
        houseNumber,
        phoneNumber,
        poId,
        email,
      },
    })
    if (result.status === 200) {
      return result.data
    }

    return []
  },
  async addCustomer(quoteId, reference, customerSource) {
    try {
      const result = await axios.put(`${quoteId}/AddCustomer`, null, {
        params: {
          reference,
          customerSource,
        },
      })

      if (result.status === 200) {
        return result.data
      }
      return {}
    } catch (e) {
      return Promise.reject(e)
    }
  },
  async removeCustomer(quoteId) {
    try {
      const result = await axios.delete(`${quoteId}/RemoveCustomer`)

      if (result.status === 200) {
        return result.data
      }
      return {}
    } catch (e) {
      return Promise.reject(e)
    }
  },
  async addCustomerCompany(quoteId, reference, customerCompanySource) {
    try {
      const result = await axios.put(`${quoteId}/AddCustomerCompany`, null, {
        params: {
          reference,
          customerCompanySource,
        },
      })

      if (result.status === 200) {
        return result.data
      }
      return {}
    } catch (e) {
      return Promise.reject(e)
    }
  },
  async removeCompany(quoteId) {
    try {
      const result = await axios.delete(`${quoteId}/RemoveCompany`)

      if (result.status === 200) {
        return result.data
      }
      return {}
    } catch (e) {
      return Promise.reject(e)
    }
  },
  async addLeaseCompany(quoteId, reference, customerCompanySource) {
    try {
      const result = await axios.put(`${quoteId}/AddLeaseCompany`, null, {
        params: {
          reference,
          customerCompanySource,
        },
      })

      if (result.status === 200) {
        return result.data
      }
      return {}
    } catch (e) {
      return Promise.reject(e)
    }
  },
  async addLeaseReference(quoteId, leaseReference) {
    try {
      const result = await passThroughAxios.put(
        `quotes/${quoteId}/lease-reference-add`,
        leaseReference
      )
      if (result.status === 200) {
        return result.data
      }
      return {}
    } catch (e) {
      return Promise.reject(e)
    }
  },
  async removeLeaseCompany(quoteId) {
    try {
      const result = await axios.delete(`${quoteId}/RemoveLeaseCompany`)

      if (result.status === 200) {
        return result.data
      }
      return {}
    } catch (e) {
      return Promise.reject(e)
    }
  },
  async removeLeaseReference(quoteId) {
    try {
      const result = await passThroughAxios.delete(`quotes/${quoteId}/lease-reference`)

      if (result.status === 200) {
        return result.data
      }
      return {}
    } catch (e) {
      return Promise.reject(e)
    }
  },
}
